module.exports = __webpack_public_path__ + "img/metro.7ec4312.jpg";